import { getSiteUrl } from './siteConfig';

/** Success/cancel URLs for campaign Stripe Checkout (same pattern as AI tokens). */
export function buildEmailCampaignCheckoutUrls(campaignId: string): {
  successUrl: string;
  cancelUrl: string;
} {
  const base = getSiteUrl().replace(/\/$/, '');
  const path =
    typeof window !== 'undefined' && window.location.pathname
      ? window.location.pathname
      : '/marketing';
  const params = new URLSearchParams(
    typeof window !== 'undefined' ? window.location.search : '',
  );
  params.delete('session_id');
  params.set('email_campaign_checkout', '1');
  params.set('campaign_id', campaignId);
  const successUrl = `${base}${path}?${params.toString()}`;

  const cancelParams = new URLSearchParams(
    typeof window !== 'undefined' ? window.location.search : '',
  );
  cancelParams.delete('session_id');
  cancelParams.delete('campaign_id');
  cancelParams.set('email_campaign_checkout', 'cancelled');
  const cancelUrl = `${base}${path}?${cancelParams.toString()}`;

  return { successUrl, cancelUrl };
}

export function campaignCheckoutPayload(data: unknown): {
  requiresCheckout?: boolean;
  checkoutUrl?: string;
} | null {
  if (!data || typeof data !== 'object') return null;
  return data as { requiresCheckout?: boolean; checkoutUrl?: string };
}

export function redirectToCampaignCheckout(data: unknown): boolean {
  const payload = campaignCheckoutPayload(data);
  if (payload?.requiresCheckout && payload.checkoutUrl) {
    window.location.href = payload.checkoutUrl;
    return true;
  }
  return false;
}
